var cilBrushAlt = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M56,256V496H456V256a48.055,48.055,0,0,0-48-48H321.383l13.075-106.263.068-.677a78.777,78.777,0,1,0-157.052,0l.027.338L190.617,208H104A48.055,48.055,0,0,0,56,256ZM424,464H88V320H424ZM226.8,240,209.348,98.192a46.777,46.777,0,1,1,93.3,0L285.205,240H408a16.019,16.019,0,0,1,16,16v32H88V256a16.019,16.019,0,0,1,16-16Z' class='ci-primary'/>"];

export { cilBrushAlt };

